module.exports = __webpack_public_path__ + "img/logo.6619cd3b.gif";